// import Swiper from "swiper/dist/js/swiper.js";
import Swiper from 'swiper/bundle';

export default class CarouselMosaic {
  constructor() {
    this.mosaic = document.querySelectorAll(".jsMosaic");

    // helpers
    this._details = {};

    if (this.mosaic.length > 0) this.init();
  }

  setCarousel(i, index) {
    this.mosaicContent = i.querySelector(".jsMosaicContent");
    this.mosaicPagination = i.querySelector(".jsMosaicPagination");

    let changeMosaic = (index, i) => {
      let el = i.querySelectorAll(".jsMosaicImg");

      for (let i = 0; el.length > i; i++) {
        parseInt(el[i].dataset.id) === index
          ? el[i].classList.add("active")
          : el[i].classList.remove("active");
      }
    };

    let config = {
      autoplay: {
        delay: 7000
      },
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.mosaicPagination,
        clickable: true,
        renderBullet: (index, className) =>
          '<span class="carousel-bullet__item ' + className + '"></span>'
      },
      on: {
        slideChange: function() {
          changeMosaic(this.activeIndex, i);
        }
      }
    };

    this._details = new Swiper(this.mosaicContent, config);
  }

  init() {
    for (let i = 0; i < this.mosaic.length; i++) {
      const el = this.mosaic[i];
      this.setCarousel(el, i);
    }
  }
}
